import iconEmailClock from '../../../../assets/icons/icon_email_clock.svg';
import iconEmailHourglass from '../../../../assets/icons/icon_email_hourglass.svg';
import iconNofileDownloaded from '../../../../assets/icons/icon_no-file-downloaded.svg';

export const fileDownloadStatus = {
  willReceiveByEmail: {
    title: 'Você receberá o arquivo por e-mail',
    message: 'Precisamos de um tempo para processar as informações solicitadas. Te enviaremos um e-mail quando o arquivo estiver disponível para download.',
    confirmButton: null,
    cancelButton: null,
    icon: iconEmailClock,
    cancelBtnWidth: null,
    confirmBtnWidth: null,
    closeButton: true,
  },
  willDelay: {
    title: 'O envio do arquivo pode demorar mais de 20 minutos',
    message: 'Sua solicitação possui uma grande quantidade dados. Te enviaremos um e-mail quando o arquivo estiver disponível para download.',
    confirmButton: null,
    cancelButton: null,
    icon: iconEmailHourglass,
    cancelBtnWidth: '200px',
    confirmBtnWidth: '200px',
    closeButton: true,
  },
  willNotDownload: {
    title: 'A solicitação é muito grande para ser processada',
    message: 'Não é possível fazer download de arquivos com mais de 1 milhão de linhas. Revise os filtros e tente novamente.',
    confirmButton: 'REVISAR FILTROS',
    cancelButton: 'FECHAR',
    icon: iconNofileDownloaded,
    cancelBtnWidth: '200px',
    confirmBtnWidth: '200px',
    closeButton: false,
  },
  noDataForDownload: {
    title: 'Nenhum resultado encontrado',
    message: 'Não foram encontrados dados para download. Revise os filtros e tente novamente.',
    confirmButton: null,
    cancelButton: null,
    icon: iconNofileDownloaded,
    cancelBtnWidth: '200px',
    confirmBtnWidth: '200px',
    closeButton: true,
  },
};

export const boxplotGroupBy = [
  {
    label: 'Produto',
    value: 'produto',
  },
  {
    label: 'Rede',
    value: 'rede',
  },
  {
    label: 'Produto e rede',
    value: 'produtoRede',
  },
  {
    label: 'UF',
    value: 'uf',
  },
  {
    label: 'Produto e UF',
    value: 'produtoUf',
  },
  {
    label: 'Fabricante',
    value: 'fabricante',
  },
  {
    label: 'Fabricante e UF',
    value: 'fabricanteUf',
  },
  {
    label: 'Região',
    value: 'regiao',
  },
  {
    label: 'Produto e região',
    value: 'produtoRegiao',
  },
  {
    label: 'Fabricante e região',
    value: 'fabricanteRegiao',
  },
  {
    label: 'Consolidado',
    value: 'semAgrupamento',
  },
];

export const CANAL_TOOLTIP = {
  FISICO: 'Preços praticados na loja física, nota fiscal ou em Apps quando correspondem aos preços da loja',
  DIGITAL: 'Preços praticados em sites/apps do varejo físico',
};

export const ADS_TOOLTIP = 'Veja somente produtos com informações de anúncios promocionais na análise';

export const FILTER_CLEAR_LIST = [
  'rede',
  'tipoLoja',
  'cnpj',
  'fabricante',
  'marca',
  'conteudo',
  'tipoProduto',
  'secao',
  'categoria',
  'mecanica',
  'grupoMidia',
  'midia',
  'uf',
  'cidade',
  'endereco',
  'regiao',
  'tipoPreco',
  'origemPreco',
  'raio',
  'produto',
  'pmc',
  'rebaixaPreco',
  'marcaPropria',
];

export const PRODUCT_WARNING_NO_DATA = 'Existem opções removidas neste filtro por não possuirem dados com os filtros alterados';

export const PRODUCT_WARNING_NO_DATA_TOOLTIP =
  'Você pode copiar os códigos identificadores do Excel e colar no campo de busca de uma vez para selecionar diversos produtos ao mesmo tempo. Produtos não encontrados no painel serão desconsiderados e produtos duplicados serão considerados apenas uma vez.';

export const PRODUCT_FILTER_LOCALE = {
  noResultsText: 'Nenhum item encontrado',
  searchPlaceholder: 'Busque o identificador ou descrição do produto',
};

export const PRICE_VIEW = [
  { label: 'Preço médio', value: 'precoMedio' },
  { label: 'Preço mínimo', value: 'precoMinimo' },
  { label: 'Preço máximo', value: 'precoMaximo' },
  { label: 'Preço mais frequente', value: 'precoMaisFrequente' },
  { label: 'Mediana', value: 'mediana' },
  { label: 'Quartil inferior', value: 'quartilInferior' },
  { label: 'Quartil superior', value: 'quartilSuperior' },
];

export const PRICE_VIEW_NAMES = {
  precoMedio: 'preco_medio',
  precoMinimo: 'preco_minimo',
  precoMaximo: 'preco_maximo',
  precoMaisFrequente: 'preco_moda',
  mediana: 'preco_mediano',
  quartilInferior: 'preco_quartil_inferior',
  quartilSuperior: 'preco_quartil_superior',
};

export const PRICE_VIEW_LABELS = {
  precoMedio: 'Preço médio',
  precoMinimo: 'Preço mínimo',
  precoMaximo: 'Preço máximo',
  precoMaisFrequente: 'Preço mais frequente',
  mediana: 'Mediana',
  quartilInferior: 'Quartil inferior',
  quartilSuperior: 'Quartil superior',
};

export const PRICE_TYPE_FILTER_OPTIONS = [
  {
    id: 'paid-price',
    label: 'Preço pago',
    value: 'PRECO_PAGO',
    tooltip: 'Preço promocionado, quando há promoção',
  },
  {
    id: 'regular-price',
    label: 'Preço regular',
    value: 'PRECO_REGULAR',
    tooltip: 'Preço original, sem promoção',
  },
  {
    id: 'unit-measurement',
    label: 'Por unidade de medida',
    value: 'PRECO_POR_UNIDADE_MEDIDA',
    tooltip: 'Preço pago por unidade de medida',
  },
];

export const PANEL_FILTER_DATA = [
  {
    name: 'tipoPreco',
    cleanable: true,
    searchable: false,
    title: 'Tipo de preço',
    placeholder: 'Selecione um tipo de preço',
    onSelect: 'handleSelect',
    onSearch: 'getItensFiltro',
    onChange: 'handleChange',
    tipoCampo: 1,
  },
  {
    name: 'origemPreco',
    cleanable: true,
    filter: false,
    searchable: true,
    title: 'Origem do preço',
    placeholder: 'Selecione uma origem',
    locale: {
      noResultsText: 'Nenhum item encontrado',
      searchPlaceholder: 'Digite ou busque a origem do preço desejado',
    },
    onSelect: 'handleSelect',
    onSearch: 'getItensFiltro',
    onChange: 'handleChange',
    tipoCampo: 1,
  },
  {
    name: 'pmc',
    cleanable: true,
    filter: false,
    searchable: false,
    title: 'PMC',
    placeholder: 'Selecione uma PMC',
    locale: {
      noResultsText: 'Nenhum item encontrado',
      searchPlaceholder: 'Digite ou busque a PMC desejada',
    },
    onSelect: 'handleSelect',
    onSearch: 'getItensFiltro',
    onChange: 'handleChange',
    tipoCampo: 1,
  },
  {
    name: 'rebaixaPreco',
    cleanable: true,
    filter: false,
    searchable: false,
    title: 'Rebaixa de preço',
    placeholder: 'Selecione uma rebaixa de preço',
    locale: {
      noResultsText: 'Nenhum item encontrado',
      searchPlaceholder: 'Digite ou busque a rebaixa de preço desejada',
    },
    onSelect: 'handleSelect',
    onSearch: 'getItensFiltro',
    onChange: 'handleChange',
    tipoCampo: 1,
  },
  {
    name: 'tipoProduto',
    cleanable: true,
    searchable: false,
    title: 'Tipo de produto',
    placeholder: 'Selecione um tipo de produto',
    onSelect: 'handleSelect',
    onSearch: 'getItensFiltro',
    onChange: 'handleChange',
    tipoCampo: 1,
    tooltipMessage: 'Alguns exemplos de produtos sem código de barras são frutas e legumes que são comercializados por peso (a granel).',
  },
  {
    name: 'fabricante',
    cleanable: true,
    filter: false,
    searchable: true,
    title: 'Fabricante',
    placeholder: 'Selecione um fabricante',
    locale: {
      noResultsText: 'Nenhum item encontrado',
      searchPlaceholder: 'Digite ou busque o fabricante de produtos desejado',
    },
    onSelect: 'handleSelect',
    onSearch: 'getItensFiltro',
    onChange: 'handleChange',
    tipoCampo: 1,
  },
  {
    name: 'marca',
    cleanable: true,
    filter: false,
    searchable: true,
    title: 'Marca',
    placeholder: 'Selecione uma marca',
    locale: {
      noResultsText: 'Nenhum item encontrado',
      searchPlaceholder: 'Digite ou busque a marca desejada',
    },
    onSelect: 'handleSelect',
    onSearch: 'getItensFiltro',
    onChange: 'handleChange',
    tipoCampo: 1,
  },
  {
    name: 'marcaPropria',
    cleanable: true,
    filter: false,
    searchable: false,
    title: 'Marca própria',
    placeholder: 'Selecione uma marca própria',
    locale: {
      noResultsText: 'Nenhum item encontrado',
      searchPlaceholder: 'Digite ou busque a marca própria desejada',
    },
    onSelect: 'handleSelect',
    onSearch: 'getItensFiltro',
    onChange: 'handleChange',
    tipoCampo: 1,
  },
  {
    name: 'categoria',
    cleanable: true,
    filter: false,
    searchable: true,
    title: 'Categoria',
    placeholder: 'Selecione uma categoria',
    locale: {
      noResultsText: 'Nenhum item encontrado',
      searchPlaceholder: 'Digite ou busque a categoria de produtos desejada',
    },
    onSelect: 'handleSelect',
    onSearch: 'getItensFiltro',
    onChange: 'handleChange',
    tipoCampo: 1,
  },
  {
    name: 'secao',
    cleanable: true,
    filter: false,
    searchable: true,
    title: 'Seção',
    placeholder: 'Selecione uma seção',
    locale: {
      noResultsText: 'Nenhum item encontrado',
      searchPlaceholder: 'Digite ou busque a seção de produtos desejada',
    },
    onSelect: 'handleSelect',
    onSearch: 'getItensFiltro',
    onChange: 'handleChange',
    tipoCampo: 1,
  },
  {
    name: 'conteudo',
    cleanable: true,
    filter: false,
    searchable: true,
    title: 'Conteúdo',
    placeholder: 'Selecione um conteúdo',
    locale: {
      noResultsText: 'Nenhum item encontrado',
      searchPlaceholder: 'Digite ou busque o conteúdo de produtos desejado',
    },
    onSelect: 'handleSelect',
    onSearch: 'getItensFiltro',
    onChange: 'handleChange',
    tipoCampo: 1,
  },
  {
    name: 'rede',
    cleanable: true,
    filter: false,
    searchable: true,
    title: 'Rede',
    placeholder: 'Selecione uma rede',
    locale: {
      noResultsText: 'Nenhum item encontrado',
      searchPlaceholder: 'Digite ou busque a rede desejada',
    },
    onSelect: 'handleSelect',
    onSearch: 'getItensFiltro',
    onChange: 'handleChange',
    tipoCampo: 1,
  },
  {
    name: 'tipoLoja',
    cleanable: true,
    filter: true,
    searchable: true,
    title: 'Tipo de loja',
    placeholder: 'Selecione um tipo de loja',
    locale: {
      noResultsText: 'Nenhum item encontrado',
      searchPlaceholder: 'Digite ou busque o tipo de loja desejado',
    },
    onSelect: 'handleSelect',
    onSearch: 'getItensFiltro',
    onChange: 'handleChange',
    tipoCampo: 1,
  },
  {
    name: 'cnpj',
    cleanable: true,
    filter: true,
    searchable: true,
    title: 'Loja',
    placeholder: 'Selecione uma ou mais lojas específicas',
    locale: {
      noResultsText: 'Nenhum item encontrado',
      searchPlaceholder: 'Digite o cnpj da loja desejada',
    },
    onSelect: 'handleSelect',
    onSearch: 'getItensFiltro',
    onChange: 'handleChange',
    tipoCampo: 1,
  },
  {
    name: 'uf',
    cleanable: true,
    filter: true,
    searchable: true,
    title: 'UF',
    placeholder: 'Selecione uma UF',
    locale: {
      noResultsText: 'Nenhum item encontrado',
      searchPlaceholder: 'Digite ou busque a UF desejada',
    },
    onSelect: 'handleSelect',
    onSearch: 'getItensFiltro',
    onChange: 'handleChange',
    tipoCampo: 1,
  },
  {
    name: 'cidade',
    filter: false,
    title: 'Cidade',
    placeholder: 'Selecione uma cidade',
    locale: {
      noResultsText: 'Nenhum item encontrado',
      searchPlaceholder: 'Digite ou busque a cidade desejada',
    },
    onSelect: 'handleSelect',
    onSearch: 'getItensFiltro',
    onChange: 'handleChange',
    tipoCampo: 1,
  },
  {
    name: 'endereco',
    cleanable: true,
    filter: false,
    searchable: true,
    title: 'Endereço',
    placeholder: 'Digite um endereço',
    locale: { noResultsText: 'Pesquise o endereço desejado' },
    onSelect: 'handleSelect',
    onSearch: 'searchEndereco',
    onClean: 'handleSelect',
    tipoCampo: 2,
  },
  {
    name: 'regiao',
    filter: false,
    title: 'Região',
    placeholder: 'Selecione uma região',
    locale: {
      noResultsText: 'Nenhum item encontrado',
      searchPlaceholder: 'Digite ou busque a região desejada',
    },
    onSelect: 'handleSelect',
    onSearch: 'getItensFiltro',
    onChange: 'handleChange',
    tipoCampo: 1,
  },
  {
    name: 'mecanica',
    filter: false,
    title: 'Mecânica',
    placeholder: 'Selecione uma mecânica',
    locale: {
      noResultsText: 'Nenhum item encontrado',
      searchPlaceholder: 'Digite ou busque a mecânica desejada',
    },
    onSelect: 'handleSelect',
    onSearch: 'getItensFiltro',
    onChange: 'handleChange',
    tipoCampo: 1,
  },
  {
    name: 'grupoMidia',
    filter: false,
    title: 'Grupo de mídia',
    placeholder: 'Selecione um grupo de mídia',
    locale: {
      noResultsText: 'Nenhum item encontrado',
      searchPlaceholder: 'Digite ou busque o grupo de mídia desejada',
    },
    onSelect: 'handleSelect',
    onSearch: 'getItensFiltro',
    onChange: 'handleChange',
    tipoCampo: 1,
  },
  {
    name: 'midia',
    filter: false,
    title: 'Mídia',
    placeholder: 'Selecione uma mídia',
    locale: {
      noResultsText: 'Nenhum item encontrado',
      searchPlaceholder: 'Digite ou busque a mídia desejada',
    },
    onSelect: 'handleSelect',
    onSearch: 'getItensFiltro',
    onChange: 'handleChange',
    tipoCampo: 1,
  },
];

export const PANEL_FILTER_TYPE_DATA = [
  {
    icon: 'shopping-cart',
    title: 'LOJA',
    itens: [
      {
        name: 'rede',
        title: 'Rede',
      },
      {
        name: 'tipoLoja',
        title: 'Tipo de loja',
      },
      {
        name: 'cnpj',
        title: 'Loja',
      },
    ],
  },
  {
    icon: 'shopping-basket',
    title: 'PRODUTO',
    itens: [
      {
        name: 'secao',
        title: 'Seção',
      },
      {
        name: 'categoria',
        title: 'Categoria',
      },
      {
        name: 'fabricante',
        title: 'Fabricante',
      },
      {
        name: 'marca',
        title: 'Marca',
      },
      {
        name: 'marcaPropria',
        title: 'Marca própria',
        isNew: true,
      },
      {
        name: 'conteudo',
        title: 'Conteúdo',
      },
      {
        name: 'tipoProduto',
        title: 'Tipo de produto',
      },
    ],
  },
  {
    icon: 'crown',
    title: 'ANÚNCIOS',
    itens: [
      {
        name: 'mecanica',
        title: 'Mecânica',
      },
      {
        name: 'grupoMidia',
        title: 'Grupo de mídia',
      },
      {
        name: 'midia',
        title: 'Mídia',
      },
    ],
  },
  {
    icon: 'map-marker',
    title: 'LOCALIZAÇÃO',
    itens: [
      {
        name: 'regiao',
        title: 'Região',
      },
      {
        name: 'uf',
        title: 'UF',
      },
      {
        name: 'cidade',
        title: 'Cidade',
      },
      {
        name: 'endereco',
        title: 'Endereço',
      },
    ],
  },
  {
    icon: 'tag',
    title: 'PREÇO',
    itens: [
      {
        name: 'tipoPreco',
        title: 'Tipo de preço',
      },
      {
        name: 'origemPreco',
        title: 'Origem do preço',
      },
      {
        name: 'pmc',
        title: 'PMC',
      },
      {
        name: 'rebaixaPreco',
        title: 'Rebaixa de preço',
        isNew: true,
      },
    ],
  },
];

export const PANEL_RADIUS_DATA = [
  {
    label: '2 KM',
    value: 2,
  },
  {
    label: '3 KM',
    value: 3,
  },
  {
    label: '4 KM',
    value: 4,
  },
  {
    label: '5 KM',
    value: 5,
  },
  {
    label: '6 KM',
    value: 6,
  },
  {
    label: '7 KM',
    value: 7,
  },
  {
    label: '8 KM',
    value: 8,
  },
  {
    label: '9 KM',
    value: 9,
  },
  {
    label: '10 KM',
    value: 10,
  },
];

export const PMC_SELECT_DATA = [
  {
    label: 'SIM',
    value: 'SIM',
  },
  {
    label: 'NÃO',
    value: 'NAO',
  },
];

export const REBAIXA_PRECO_SELECT_DATA = [
  {
    label: 'SIM',
    value: 'Sim',
  },
  {
    label: 'NÃO',
    value: 'Não',
  },
];
